import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
  connectAuthEmulator,
} from 'firebase/auth';

// Configuration Firebase (identique à celle du frontend)
const firebaseConfig = {
  apiKey: "AIzaSyC_i7ZRi55XNp7XnNcTsAmMcyrwPo6DXf0",
  authDomain: "dicto-fr.firebaseapp.com",
  projectId: "dicto-fr",
  storageBucket: "dicto-fr.firebasestorage.app",
  messagingSenderId: "786483607560",
  appId: "1:786483607560:web:0a5017b08f49dca1de39bd"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Erreur configuration persistance Firebase:', error);
});

// Dev local : Auth émulateur (même comptes / tokens que app + parent-web + backend).
// Désactiver : VITE_USE_FIREBASE_EMULATOR=false dans .env
// Lancer l'émulateur : npm run emulator (frontend / racine)
const useEmulatorExplicit = import.meta.env.VITE_USE_FIREBASE_EMULATOR;
const useEmulator =
  useEmulatorExplicit === 'true' ||
  (import.meta.env.DEV && useEmulatorExplicit !== 'false');

if (useEmulator && typeof window !== 'undefined' && !globalThis.__adminWebAuthEmulator) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  globalThis.__adminWebAuthEmulator = true;
}

export { auth, googleProvider, useEmulator as isFirebaseEmulator };
